import api from '@/api/conference'
import { CONFERENCE_SET_ROOMS, CONFERENCE_ADD_ROOM, CONFERENCE_UPDATE_ROOM, CONFERENCE_CLOSE_ROOM } from './mutations'

export default {
  loadRoomsList: async ({ commit }, parish) => {
    try {
      let { rooms } = await api.loadRoomsList(parish)
      commit(CONFERENCE_SET_ROOMS, rooms)
    } catch (error) {
      throw new Error(error.message)
    }
  },
  openRoom: async ({ commit }, { parish, room }) => {
    delete room.id
    let result = await api.openRoom(parish, room)
    commit(CONFERENCE_ADD_ROOM, result.conference_room)
    return { message: result.message }
  },
  updateRoom: async ({ commit }, { room }) => {
    let result = await api.updateRoom(room)
    commit(CONFERENCE_UPDATE_ROOM, result.conference_room)
    return { message: result.message }
  },
  closeRoom: async ({ commit }, { room }) => {
    const { message } = await api.closeRoom(room)
    commit(CONFERENCE_CLOSE_ROOM, room)
    return { message }
  },
  voteRoom: async ({ commit }, { room }) => {
    console.log('voteRoom')
  }
}
